import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function InDevelopment({ children }: Props) {
  if (import.meta.env.VITE_APP_ENV === 'sandbox') return <>{children}</>;

  return null;
}
